var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 52
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1282_48132)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m.047 43.946.218-.957c.166-.71.792-.987 1.478-.769.738.22 2.269.656 3.97.656 1.425 0 2.276-.85 2.276-2.08 0-3.315-7.718-2.464-7.718-8.515 0-3.202 2.766-5.2 6.24-5.2 1.643 0 3.067.384 4.137.739.709.248.957.904.738 1.59l-.272.85c-.218.686-.791 1.01-1.506.769-.987-.302-1.891-.52-3.09-.52-1.56 0-2.08.791-2.08 1.725 0 3.09 7.716 2.133 7.716 8.539 0 3.693-3.09 5.53-6.435 5.53-2.11 0-3.888-.466-4.898-.791-.656-.219-.934-.822-.768-1.56zM14.453 28.316c0-.738.49-1.229 1.23-1.229h1.453c.739 0 1.229.49 1.229 1.23v3.61c.603-.331 1.53-.656 2.435-.656 2.9 0 5.418 1.672 5.418 5.72v8.078c0 .738-.49 1.229-1.229 1.229h-1.454c-.738 0-1.229-.49-1.229-1.23V37.21c0-1.998-.685-2.63-1.861-2.63-.71 0-1.395.219-2.08.49v9.993c0 .738-.49 1.229-1.23 1.229h-1.453c-.738 0-1.229-.49-1.229-1.23V28.31zM28.71 37.54c0-3.911 2.571-6.27 6.105-6.27s6.104 2.353 6.104 6.27v2.494c0 3.912-2.57 6.27-6.104 6.27s-6.104-2.352-6.104-6.27zm6.105 5.449c1.643 0 2.216-1.206 2.216-3.09v-2.217c0-1.89-.573-3.09-2.216-3.09s-2.216 1.205-2.216 3.09v2.216c0 1.891.573 3.09 2.216 3.09M43.213 37.263c0-3.776 2.765-5.998 6.021-5.998s5.998 2.216 5.998 5.998v3.013c0 4.054-2.765 6.022-5.667 6.022-.904 0-1.861-.331-2.434-.656v4.845c0 .739-.49 1.23-1.23 1.23h-1.453c-.739 0-1.23-.491-1.23-1.23V37.27zm5.998 5.72c1.175 0 2.11-.768 2.11-2.848v-2.736c0-1.891-.905-2.819-2.08-2.819-1.177 0-2.11.928-2.11 2.819v5.093c.685.272 1.37.49 2.08.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_1282_48132)",
    d: "m61.277 42.41 9.378 5.412 7.292-4.213-16.67-9.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_1282_48132)",
    d: "M61.277 49.636c0 1.602 1.732 2.6 3.12 1.803l6.258-3.617-9.378-5.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_1282_48132)",
    d: "M82.125 37.6 64.39 27.36c-1.382-.799-3.12.2-3.12 1.801v4.822l16.67 9.626 4.178-2.41c1.382-.798 1.382-2.802 0-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_1282_48132)",
    d: "M80.973 34.503c-.22 0-.444-.053-.645-.171a1.29 1.29 0 0 1-.472-1.761 5.4 5.4 0 0 0 .543-4.13 5.4 5.4 0 0 0-2.535-3.304 5.4 5.4 0 0 0-4.13-.543 5.4 5.4 0 0 0-3.303 2.535 1.29 1.29 0 0 1-1.761.472 1.293 1.293 0 0 1-.473-1.76 7.97 7.97 0 0 1 4.87-3.741 7.95 7.95 0 0 1 6.086.804 7.97 7.97 0 0 1 3.74 4.869 7.95 7.95 0 0 1-.804 6.086 1.29 1.29 0 0 1-1.117.644"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M3.758 5.897H1.223c-.573 0-.957-.384-.957-.957v-.745c0-.579.384-.963.957-.963h8.202c.573 0 .957.384.957.958v.744c0 .573-.384.957-.957.957H6.89v10.785c0 .573-.384.957-.958.957H4.715c-.573 0-.957-.384-.957-.957zM10.637 7.451c0-.573.384-.957.957-.957h1.11c.574 0 .958.384.958.957v5.667c0 1.472.597 2.216 1.536 2.216s1.537-.744 1.537-2.216V7.451c0-.573.384-.957.957-.957h1.129c.573 0 .957.384.957.957v5.774c0 3.066-2.086 4.685-4.58 4.685-2.493 0-4.561-1.619-4.561-4.685zM29.256 11.091c0-3.049 2.003-4.88 4.75-4.88 2.749 0 4.752 1.831 4.752 4.88v1.939c0 3.049-2.004 4.88-4.751 4.88s-4.751-1.831-4.751-4.88zm4.75 4.237c1.277 0 1.726-.94 1.726-2.405v-1.725c0-1.472-.449-2.405-1.725-2.405s-1.726.94-1.726 2.405v1.725c0 1.472.45 2.405 1.726 2.405M40.902 10.518c0-2.576 1.98-4.302 4.515-4.302.343 0 .662.024 1.046.083.467.083 1.022.45.85 1.17l-.147.638c-.106.467-.467.851-1.129.727a4 4 0 0 0-.596-.041c-.958 0-1.513.727-1.513 1.725v6.157c0 .574-.384.958-.957.958H41.86c-.574 0-.958-.384-.958-.957zM51.154 4.148a1.28 1.28 0 0 1 1.235-.916h1.702c.573 0 1.063.36 1.235.916l3.752 12.486c.171.573-.106.999-.68.999h-1.317c-.573 0-.958-.278-1.111-.834l-.727-2.64h-4.006l-.727 2.617c-.148.555-.514.85-1.087.85H48.08c-.573 0-.85-.425-.68-.998l3.753-12.486zm3.386 7.475L53.795 8.9c-.189-.662-.384-1.554-.555-2.452-.172.892-.384 1.79-.556 2.452l-.744 2.724zM61.207 4.19c0-.574.384-.958.957-.958h3.753c3.049 0 4.94 1.684 4.94 4.048 0 1.341-.68 2.257-1.809 2.79 1.448.53 2.346 1.577 2.346 3.172 0 2.429-2.192 4.39-5.371 4.39h-3.859c-.573 0-.957-.383-.957-.957zm4.473 4.792c1.3 0 2.003-.662 2.003-1.554 0-.893-.531-1.537-1.855-1.537h-1.49v3.09zm.32 5.986c1.382 0 2.215-.745 2.215-1.726 0-.98-.662-1.725-2.044-1.725h-1.832v3.45zM73.309 8.875c0-3.982 2.511-5.92 5.88-5.92 1.276 0 2.345.17 3.279.401.555.148.786.62.661 1.17l-.17.727c-.13.556-.663.786-1.17.662-.68-.148-1.472-.301-2.577-.301-1.708 0-2.772.916-2.772 3.516v2.576c0 2.618 1.064 3.534 2.772 3.534 1.063 0 1.897-.13 2.6-.296.555-.148 1.022.083 1.152.638l.171.745c.13.555-.189 1.046-.768 1.193-.768.19-1.855.384-3.173.384-3.368 0-5.88-1.938-5.88-5.92V8.875zM27.27 6.488h-1.046v-2.31c0-.573-.384-.958-.957-.958h-1.129c-.573 0-.957.385-.957.958v2.316h-1.064a.67.67 0 0 0-.342.095.7.7 0 0 0-.378.65v.531c0 .45.295.745.744.745h1.046v8.16c0 .574.384.958.957.958h1.129c.573 0 .957-.384.957-.957V8.515h1.046c.45 0 .745-.301.745-.745V7.24c0-.45-.296-.745-.745-.745z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1282_48132",
    x1: 55.28,
    x2: 80.848,
    y1: 34.486,
    y2: 49.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1282_48132",
    x1: 50.511,
    x2: 71.796,
    y1: 39.603,
    y2: 52.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1282_48132",
    x1: 60.941,
    x2: 104.579,
    y1: 29.309,
    y2: 55.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1282_48132",
    x1: 69.497,
    x2: 84.063,
    y1: 22.791,
    y2: 31.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1282_48132"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M0 0h83.165v52H0z"
  })))));
};
export default SvgLogo;